import CritiqueReview from './CritiqueReview'
export default CritiqueReview
